

interface HeroProps {
  onBookNow: () => void;
}

export default function Hero({ onBookNow }: HeroProps) {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/b0b045ca7b172e2933037472ec73759c.jpg')`
      }}
    >
      <div className="container mx-auto px-4 text-center text-white z-10">
        <div className="max-w-4xl mx-auto">
          <img 
            src="https://static.readdy.ai/image/f22afdb20e58582f8eb53f676b1a48ba/ec83d9edada8a69b1a9d15a02fd82904.png" 
            alt="Yaad Boyz Detailing Logo" 
            className="w-64 h-auto mx-auto mb-8"
          />
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Premium Auto Detailing Services</h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200">
            Professional car care that brings out the best in your vehicle. Expert detailing services for discerning car owners.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={onBookNow}
              className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-4 px-8 rounded-lg text-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Book Now
            </button>
            <a 
              href="#services"
              className="bg-green-700 hover:bg-green-800 text-white font-bold py-4 px-8 rounded-lg text-lg transition-all duration-300 whitespace-nowrap cursor-pointer inline-block"
            >
              View Services
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

